module.exports = __webpack_public_path__ + "static/media/kitap.d499cbf9.png";